<script>
	import { Router, Link, Route } from "svelte-routing";
	import Home from "./routes/+page.svelte";
	import About from "./routes/About.svelte";
	import Legal from "./routes/Legal.svelte";
	import Login from "./routes/Login.svelte";
	import Profile from "./routes/Profile.svelte";
	import BrfPage from "./routes/brf/[id].svelte";
	import ReportPage from "./routes/brf/Report.svelte";
	import TopList from "./routes/TopList.svelte";
	import Bank from "./routes/Bank.svelte";
	import CookieConsent from "./components/common/CookieConsent.svelte";
	import TopBar from "./components/TopBar.svelte";

	export let url = "";
</script>

<Router {url}>
	<TopBar />
	<CookieConsent />
	<nav>
		<Link to="/">Home</Link>
		<Link to="/about">About</Link>
		<Link to="/legal">Legal</Link>
		<Link to="/login">Login</Link>
		<Link to="/profile">Profile</Link>
	</nav>
	<main>
		<Route path="/about" component={About} />
		<Route path="/legal" component={Legal} />
		<Route path="/login" component={Login} />
		<Route path="/toplist" component={TopList} />
		<Route path="/bank" component={Bank} />
		<Route path="/profile" component={Profile} />
		<Route path="/brf/:id" let:params>
			<BrfPage id={params.id} />
		</Route>
		<Route path="/brf/:id/:name" let:params>
			<BrfPage id={params.id} />
		</Route>
		<Route path="/brf/:id/:slug/report" let:params>
			<ReportPage id={params.id} />
		</Route>
		<Route path="/"><Home /></Route>
	</main>
	<div class="info-text">
		Boanalys kan begå misstag då mycket bygger på AI. Kontrollera viktig information.
	</div>
	<footer>
		<p>©Boanalys. All rights reserved.</p>
		<p><Link to="/about#kontakt-section">Kontakta oss</Link></p>
	</footer>
</Router>

<style>
	nav {
		display: none;
	}
</style>